import React, {Suspense} from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router';
import SdkVersionShow from '../../components/sdk_version/SdkVersion'
import SdkVersionsList from '../../components/sdk_version/SdkVersionsList'

function SdkVersion(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route path={`${path}/:sdkVersion`} component={SdkVersionShow}/>
        <Route path={`${path}`} component={SdkVersionsList}/>
      </Switch>
    </Suspense>
  )
}

export default SdkVersion
